import request from './request'

export default {
  list(data) {
    return request.post('/videoBarrage/list', data)
  },
  info(data) {
    return request.post('/videoBarrage/info', data)
  },
  enable(data) {
    return request.post('/videoBarrage/enable', data)
  },
  disable(data) {
    return request.post('/videoBarrage/disable', data)
  },
  delete(data) {
    return request.post('/videoBarrage/delete', data)
  },
}
